__turbopack_context__.v({
  "circled-chevron-right-icon": "CircledChevronRight-module-scss-module__QbIz6q__circled-chevron-right-icon",
});
